<template>
	<section v-if="grades.REPORT_OPTIONS !== undefined" id="classPage" class="class-page grades-breakdown" style="padding:15px;">
		<!-- Header -->
		<class-page-header :details="details" :current-section="0" :course="course" :menu="menu" :is-class-item-page="true"></class-page-header>

		<div class="back-link">
			<a style="cursor:pointer" @click="goToClassPage()">
				<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
			</a>
		</div>

		<div class="class-page-body">
			<div class="col-md-12 overview-top" v-if="grades.CURRENT_GRADE !== undefined">
				<div class="col-md-6 col-sm-12">
					<h2>
						{{ $t("MAIN_CONTENT.ClassGrades.markingPeriod", { code: mpCode } ) }}
					</h2>
				</div>
				<div class="col-md-3 col-sm-6">
					<label>
						{{ $t("MAIN_CONTENT.ClassGrades.currentGrade") }}
					</label>
					<p>
						{{ grades.REPORT_OPTIONS.SHOW_PERCENT_FLG === 'Y' && grades.CURRENT_GRADE.PERCENT !== '' ?  grades.CURRENT_GRADE.PERCENT + '%' : '' }}
						{{ grades.REPORT_OPTIONS.SHOW_LETTER_FLG === 'Y' && grades.CURRENT_GRADE.LETTER !== '' ? grades.CURRENT_GRADE.LETTER : '' }}
					</p>
				</div>
				<div v-if="grades.REPORT_OPTIONS.SHOW_POINTS_FLG === 'Y'" class="col-md-3 col-sm-6">
					<label>
						{{ $t("MAIN_CONTENT.ClassGrades.points") }}
					</label>
					<p v-if="grades.CURRENT_GRADE.EARNED_POINTS !== '' && grades.CURRENT_GRADE.MAX_POINTS !== ''">
						{{ $t( "MAIN_CONTENT.ClassGrades.gradesOverPointsAsterisk", { grade: grades.CURRENT_GRADE.EARNED_POINTS, points: grades.CURRENT_GRADE.MAX_POINTS } ) }}
					</p>
				</div>
			</div>
			<div>
				<small>{{ $t("MAIN_CONTENT.ClassGrades.finalAverageNote") }}</small>
			</div>

			<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_GRADE_CATEGORY_SUB_FLG === 'Y'" class="mb-2">
				<h3>{{ $t( "MAIN_CONTENT.ClassGrades.categories" ) }}</h3>
				<p v-if="grades.CATEGORIES.length === 0">
					<i>{{ $t( "MAIN_CONTENT.ClassGrades.noCategoryGrades" ) }}</i>
				</p>
				<div class="flex-container" v-if="grades.CATEGORIES.length > 0">
					<div v-for="category in grades.CATEGORIES" :key="'category-' + category.CATEGORY_CODE" class="panel-body panel-body-table">
						<table class="table table-box">
							<thead>
								<tr>
									<th colspan="2">
										{{ category.CATEGORY_NAME }}
									</th>
								</tr>
							</thead>
							<tbody>
								<template>
									<tr v-if="grades.REPORT_OPTIONS.SHOW_PERCENT_FLG === 'Y' || grades.REPORT_OPTIONS.SHOW_LETTER_FLG === 'Y'">
										<th>
											{{ $t("MAIN_CONTENT.ClassGrades.grade") }}
										</th>
										<td>
											<template v-if="grades.REPORT_OPTIONS.SHOW_PERCENT_FLG === 'Y'">
												{{ $t( 'MAIN_CONTENT.ClassGrades.percent', { percent: category.CURRENT_PERCENT } ) }} 
											</template>
											<template v-if="grades.REPORT_OPTIONS.SHOW_LETTER_FLG === 'Y'">
												{{ category.CATEGORY_GRADE_LETTER }}
											</template>
										</td>
									</tr>
									<tr v-if="grades.REPORT_OPTIONS.SHOW_POINTS_FLG === 'Y'">
										<th>
											{{ $t("MAIN_CONTENT.ClassGrades.points") }}
										</th>
										<td>
											{{ $t( 'MAIN_CONTENT.ClassGrades.currentOverMaxPoints', { current: category.PWP_CURRENT_POINTS, max: category.PWP_MAX_POINTS } ) }}
										</td>
									</tr>
									<tr v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_GRADE_ASSIGNMENT_NUM_FLG === 'Y'">
										<th>
											{{ $t("MAIN_CONTENT.ClassGrades.assignments") }}
										</th>
										<td>
											{{ category.ASSIGNMENT_COUNT }}
										</td>
									</tr>
									<tr v-if="grades.REPORT_OPTIONS.SHOW_CATEGORY_WEIGHT_FLG === 'Y'">
										<th>
											{{ $t("MAIN_CONTENT.ClassGrades.weight") }}
										</th>
										<td>
											{{ parseFloat( category.WEIGHT ).toFixed( grades.REPORT_OPTIONS.NO_OF_DECIMAL_PLACES ) }}
										</td>
									</tr>
									<tr v-if="grades.REPORT_OPTIONS.SHOW_CATEGORY_PERCENT_FLG === 'Y'">
										<th>
											{{ $t("MAIN_CONTENT.ClassGrades.markingPeriodAbbreviation") }}
										</th>
										<td>
											{{ category.PERCENT_OF_TOTAL && category.PERCENT_OF_TOTAL != 0 ? parseFloat(category.PERCENT_OF_TOTAL).toFixed( grades.REPORT_OPTIONS.NO_OF_DECIMAL_PLACES ) + '%' : '' }}
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="assignments">
				<div class="mb-1">
					<div class="row">
						<div class="col-xs-12 col-md-6">
							<h3 v-tooltip.top-center="{content: assignmentsTooltip(), trigger: 'hover click'}">
								{{ $t("MAIN_CONTENT.ClassGrades.assignmentsAllCaps") }} <i class="fas fa-question-circle"></i>
							</h3> 
						</div>
						<div class="col-xs-12 col-md-6 float-right"  v-if="grades.ASSIGNMENTS.length > 0">
							<label for="filter">
								{{ $t("MAIN_CONTENT.ClassGrades.showBy") }}
							</label>
							<select v-model="show" name="filter" id="filter">
								<option value="date">
									{{ $t("MAIN_CONTENT.ClassGrades.date") }}
								</option>
								<option value="category">
									{{ $t("MAIN_CONTENT.ClassGrades.category") }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<p v-if="grades.ASSIGNMENTS.length === 0"><i> {{ $t("MAIN_CONTENT.ClassGrades.noAssignmentGrades") }}</i></p>
				<!-- ASSIGNMENTS DISPLAYED BY DATE LAYOUT -->
				<div v-if="show === 'date'" class="display-table by-date mb-1">
					<template v-for="assignment in assignmentsByDate()">
						<div class="display-container" :key="assignment.ASSIGNMENT_CATEGORY_CODE + '-' + assignment.ASSIGNMENT_CODE">
							<div class="header col-xs-12">
								<div class="col-xs-12 col-sm-6">
									<h4>
										<strong>{{ assignment.ASSIGNMENT_NAME }}</strong> <span v-if="grades.REPORT_OPTIONS.SHOW_CATEGORIES_FLG === 'Y'">- {{ assignment.CATEGORY_NAME }}</span>
									</h4>
								</div>
								<div class="col-xs-12 col-sm-6" style="min-height: 25px;">
									<div class="score-pill float-right">
										<span v-if="!!gradeMappings[assignment.GRADE_CODE.toString().toUpperCase()]" v-tooltip.top-center="{content: assignmentsTooltip(assignment.GRADE_CODE), trigger: 'hover click'}">
											<i class="fas fa-question-circle"></i>
										</span>
										{{ $t("MAIN_CONTENT.commonContent.score") }} 
										<strong>
											<template v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_GRADE_PERCENT_FLG === 'Y'">
												{{ $t( 'MAIN_CONTENT.ClassGrades.codeOverPointsPercent', { code: assignment.GRADE_CODE, points: assignment.MAX_POINTS, percent: assignment.GRADE_PERCENT } ) }}
											</template>
											<template v-else>
												{{ $t( 'MAIN_CONTENT.ClassGrades.codeOverPoints', { code: assignment.GRADE_CODE, points: assignment.MAX_POINTS } ) }}
											</template>
										</strong>
									</div>
								</div>
							</div>
							<div class="details">
								<div class="grades-details flex-container">
									<div v-if="grades.REPORT_OPTIONS.SHOW_EXTRA_CREDIT_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.maxExtraCredit") }}</dt>
											<dd>{{ assignment.MAX_EC_POINTS }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_ASSIGNED_DATE_FLG === 'Y'"
											:class="dueSoon( assignment.END_DATE ) ? 'text-danger' : ''"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.dateAssigned") }}</dt>
											<dd>{{ assignment.START_DATE | date }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_DUE_DATE_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.dateDue") }}</dt>
											<dd>{{ assignment.END_DATE | date }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_CLASS_AVERAGE_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.classAverage") }}</dt>
											<dd>
												<template v-if="!!assignment.MEAN_POINTS || assignment.MEAN_POINTS === 0">
													{{ assignment.MEAN_POINTS }}
												</template>
												<template v-else>
													*
												</template>
											</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_HIGHER_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresHigher") }}</dt>
											<dd>{{ assignment.NUM_HIGHER }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_SAME_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresSame") }}</dt>
											<dd>{{ assignment.NUM_SAME }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_LOWER_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresLower") }}</dt>
											<dd>{{ assignment.NUM_LOWER }}</dd>
										</div>
									</div>
								</div>
								<div v-if="assignment.ASSIGNMENT_DESC && grades.REPORT_OPTIONS.SHOW_ASSIGNMENT_DESC_FLG === 'Y'" class="additional-comments">
									<h5><strong>{{ $t("MAIN_CONTENT.ClassGrades.assignmentDescription") }}</strong></h5>
									<p>{{ assignment.ASSIGNMENT_DESC }}</p>
								</div>
								<div v-if="assignment.ASSIGNMENT_COMMENTS && grades.REPORT_OPTIONS.SHOW_COMMENTS_FLG === 'Y'" class="additional-comments">
									<h5><strong>{{ $t("MAIN_CONTENT.ClassGrades.teacherComments") }}</strong></h5>
									<p>{{ assignment.ASSIGNMENT_COMMENTS }}</p>
								</div>

								<!-- Start of Assignment Skills -->
								<div v-if="grades.REPORT_OPTIONS.SHOW_SKILLS_ASSIGNED === 'Y' && assignment.SKILLS.length > 0"
											class="additional-comments">
									<h5>
										<strong>
											{{ $t("MAIN_CONTENT.ClassGrades.assignmentSkills") }}
										</strong>
									</h5>
									<ul style="list-style-type: none;">
										<li v-for="( skill, skillIndex ) in assignment.SKILLS" :key="`assignmentSkills_${skillIndex}`">
											{{ skill.LINE_ITEM_DESC }}
										</li>
									</ul>
									<!-- <p>{{ assignment.SKILLS }}</p> -->
								</div>
								<!-- End of Assignment Skills -->

								<div v-if="wasAttempted( assignment )" class="text-center mb-1" @click="reviewTest(assignment)">
									<button class="btn btn-primary">
										{{ $t("MAIN_CONTENT.ClassGrades.viewAssignmentTest") }}
									</button>
								</div>
							</div>
						</div>
					</template>
				</div>
				<!-- END OF ASSIGNMENTS DISPLAYED BY DATE LAYOUT -->

				<!-- ASSIGNMENTS DISPLAYED BY CATEGORY LAYOUT -->
				<div v-else-if="show === 'category'" class="display-table by-category mb-1">
					<template v-for="category in grades.CATEGORIES">
						<div class="display-container" :key="'assignments-' + category.CATEGORY_CODE" v-if="assignmentsByCategory( category.CATEGORY_CODE ).length">
							<div class="header">
								<h4><strong>{{ category.CATEGORY_NAME }}</strong></h4>
							</div>

							<div class="details" v-for="assignment in assignmentsByCategory( category.CATEGORY_CODE )" :key="assignment.ASSIGNMENT_CODE + '-' + category.CATEGORY_CODE">
								<div class="sub-header col-xs-12">
									<div class="col-xs-12 col-sm-6">
										<h5>
											{{ assignment.ASSIGNMENT_NAME }}
										</h5>
									</div>
									<div class="col-xs-12 col-sm-6 score-pill-height">
										<div class="score-pill float-right">
											<span v-if="!!gradeMappings[assignment.GRADE_CODE.toString().toUpperCase()]" v-tooltip.top-center="{content: assignmentsTooltip(assignment.GRADE_CODE), trigger: 'hover click'}"><i class="fas fa-question-circle"></i></span> 
											{{ $t("MAIN_CONTENT.commonContent.score") }} 
											<strong>
												<template v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_GRADE_PERCENT_FLG === 'Y'">
													{{ $t( 'MAIN_CONTENT.ClassGrades.codeOverPointsPercent', { code: assignment.GRADE_CODE, points: assignment.MAX_POINTS, percent: assignment.GRADE_PERCENT } ) }}
												</template>
												<template v-else>
													{{ $t( 'MAIN_CONTENT.ClassGrades.codeOverPoints', { code: assignment.GRADE_CODE, points: assignment.MAX_POINTS } ) }}
												</template>
											</strong>
										</div>
									</div>
								</div>
								<div class="grades-details flex-container">
									<div v-if="grades.REPORT_OPTIONS.SHOW_EXTRA_CREDIT_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.maxExtraCredit") }}</dt>
											<dd>{{ assignment.MAX_EC_POINTS }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_ASSIGNED_DATE_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.dateAssigned") }}</dt>
											<dd>{{ assignment.START_DATE | date }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_DUE_DATE_FLG === 'Y'"
											:class="dueSoon( assignment.END_DATE ) ? 'text-danger' : ''"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{$t("MAIN_CONTENT.ClassGrades.dateDue")}}</dt>
											<dd>{{ assignment.END_DATE | date }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_CLASS_AVERAGE_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{$t("MAIN_CONTENT.ClassGrades.classAverage")}}</dt>
											<dd>
												<template v-if="!!assignment.MEAN_POINTS || assignment.MEAN_POINTS === 0">
													{{ assignment.MEAN_POINTS }}
												</template>
												<template v-else>
													*
												</template>
											</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_HIGHER_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresHigher") }}</dt>
											<dd>{{ assignment.NUM_HIGHER }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_SAME_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresSame") }}</dt>
											<dd>{{ assignment.NUM_SAME }}</dd>
										</div>
									</div>
									<div v-if="grades.REPORT_OPTIONS.SHOW_STUDENT_NUM_LOWER_FLG === 'Y'"
											class="col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper">
										<div class="content">
											<dt>{{ $t("MAIN_CONTENT.ClassGrades.scoresLower") }}</dt>
											<dd>{{ assignment.NUM_LOWER }}</dd>
										</div>
									</div>
								</div>

								<div v-if="assignment.ASSIGNMENT_DESC" class="additional-comments">
									<h5><strong>{{ $t("MAIN_CONTENT.ClassGrades.assignmentDescription") }}</strong></h5>
									<p>{{ assignment.ASSIGNMENT_DESC }}</p>
								</div>
								<div v-if="assignment.ASSIGNMENT_COMMENTS && grades.REPORT_OPTIONS.SHOW_COMMENTS_FLG === 'Y'" class="additional-comments">
									<h5><strong>{{ $t("MAIN_CONTENT.ClassGrades.teacherComments") }}</strong></h5>
									<p>{{ assignment.ASSIGNMENT_COMMENTS }}</p>
								</div>

								<!-- Start of Assignment Skills -->
								<div v-if="grades.REPORT_OPTIONS.SHOW_SKILLS_ASSIGNED === 'Y' && assignment.SKILLS.length > 0"
											class="additional-comments">
									<h5>
										<strong>
											{{ $t("MAIN_CONTENT.ClassGrades.assignmentSkills") }}
										</strong>
									</h5>
									<ul style="list-style-type: none;">
										<li v-for="( skill, skillIndex ) in assignment.SKILLS" :key="`assignmentSkills_${skillIndex}`">
											{{ skill.LINE_ITEM_DESC }}
										</li>
									</ul>
								</div>
								<!-- End of Assignment Skills -->

								<div v-if="wasAttempted( assignment )" class="text-center mb-1" @click="reviewTest(assignment)">
									<button class="btn btn-primary">
										{{ $t("MAIN_CONTENT.ClassGrades.viewAssignmentTest") }}
									</button>
								</div>
							</div>
						</div>
					</template>
				</div>
				<!-- END OF ASSIGNMENTS DIPLAYED BY CATEGORY LAYOUT -->
			</div>

			<div class="display-table skill-grades" v-if="grades.REPORT_OPTIONS.SHOW_SKILL_GRADES_FLG === 'Y' && grades.SKILLS.length > 0">
				<table class="table table-box">
					<thead>
						<tr>
							<th>{{ $t( 'MAIN_CONTENT.ClassGrades.skill' ) }}</th>
							<th>{{ $t( 'MAIN_CONTENT.ClassGrades.currentGradeTitleCase' ) }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(skill, i) in grades.SKILLS" :key="i">
							<td>{{ skill.SKILL_DESCRIPTION }}</td>
							<td>{{ skill.SKILL_GRADE }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="display-table general-comment" v-if="grades.REPORT_OPTIONS.SHOW_GENERAL_COMMENTS_FLG === 'Y'">
				<div class="display-container">
					<div class="details">
						<div class="sub-header col-xs-12">
							<h4>{{ $t( 'MAIN_CONTENT.ClassGrades.generalComment' ) }}</h4>
						</div>
						<p>{{ grades.GENERAL_COMMENTS }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="back-link">
			<a style="cursor:pointer" @click="goToClassPage()">
				<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
			</a>
		</div>
	</section>
</template>

<script>
	// Sapphire local project files
	import ClassPageHeader from "./Header.vue";

	// API files
	import ClassPageDetailsResource from '../../api/ClassPageDetails';
	import ClassPageMenuResource from '../../api/ClassPageMenu';
	import CoursesResource from '../../api/Courses';
	import ClassPageGradesResources from '../../api/ClassPageGrades';

	// Third party imports
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
	import { mapActions, mapGetters } from "vuex";
	import moment from 'moment';

	export default {
		name: "Grades",
		props: {
			reportType: {
				type    : String,
				default : "GRD"
			}
		},
		data() {
			return {
				grades : {},
				show   : "category",
				menu: [],
				details: {},
				course: {},
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			/** Get the current mpCode based on the URL param */
			mpCode () {
				return this.$route.query.mpCode.toString().toUpperCase();
			},
			gradeMappings(){
				let mappings = {
					'+': 'These assignments do not have a grade at this time but do not count against the student.',
					'*': 'These assignments do not have a grade at this time and are counted as zero.',
					'EX': 'This assignment is ignored for grade calculation.',
				};

				if( !!this.grades.GRADE_MAPPINGS ){
					for( let m = 0; m < this.grades.GRADE_MAPPINGS.length; m++ ){
						mappings[this.grades.GRADE_MAPPINGS[m].GRADE_SYMBOL.toString().toUpperCase()] = this.grades.GRADE_MAPPINGS[m].MAPPING_DESC;
					}
				}

				return mappings;
			},
		},
		components: {
			ClassPageHeader
		},
		directives: {
			'tooltip': VTooltip,
		},
		methods: {
			reviewTest(assignment){
				let test = assignment.TESTS[ 0 ];
				let routeData = this.$router.resolve({
					name: "testReviewer", 
					params: {
						testRid: test.TEST_RID
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						school_id: test.SCHOOL_ID,
						course_id: test.COURSE_ID,
						section_id: test.SECTION_ID,
						teacher_rid: test.TEACHER_RID
					}
				});
				window.open(routeData.href, '_blank');
			},
			assignmentsTooltip( tip = '' ) {
				tip = tip.toString();
				if( tip === '' ) {
					let mappings = '';
					for( let mapping in this.gradeMappings){
						mappings = `${mappings} <br/> <strong>${mapping}</strong> = ${this.gradeMappings[mapping]}`;
					}
					return mappings;
				} else if( !!this.gradeMappings[tip.toUpperCase()] ) {
					return this.gradeMappings[tip.toUpperCase()];
				}

				return 'Invalid Tip Code';
			},
			fetchMenu() {
				const ClassPageMenu = new ClassPageMenuResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageMenu.get().then(()=>{
					this.menu = ClassPageMenu.getResponseData();
				});
			},
			fetchDetails() {
				const ClassPageDetails = new ClassPageDetailsResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageDetails.get().then(()=>{
					this.details = ClassPageDetails.getResponseData();
				});
			},
			fetchCourse() {
				const Course = new CoursesResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				Course.get().then(()=>{
					this.course = Course.getResponseData();
				});
			},
			fetchGrades() {
				const Grades = new ClassPageGradesResources({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						mp_code: this.$route.query.mpCode.toString(),
					},
				});

				Grades.get().then(()=>{
					this.grades = Grades.getResponseData();

					for(let a in this.grades.ASSIGNMENTS) {
						let assignment = this.grades.ASSIGNMENTS[a];

						assignment.END_DATE = moment(assignment.END_DATE);
						assignment.CREATED_DATE = moment(assignment.CREATED_DATE);
					}
					/* Filter Out test assignments that are set to not show */
					this.grades.ASSIGNMENTS = this.grades.ASSIGNMENTS.filter((itm)=>{
						return !itm.TESTS || itm.TESTS.length === 0 || itm.TESTS[0].PWP_VISIBLE_FLG === "Y";
					});
				});
			},
			dueSoon( endDate ) {
				let today = moment();

				today = today.set( "hour", 0 );
				today = today.set( "minute", 0 );
				today = today.set( "second", 0 );
				today = today.set( "millisecond", 0 );

				let end = moment( endDate );

				end = end.set( "hour", 0 );
				end = end.set( "minute", 0 );
				end = end.set( "second", 0 );
				end = end.set( "millisecond", 0 );

				let future = moment().add( 3, "days" );

				future = future.set( "hour", 0 );
				future = future.set( "minute", 0 );
				future = future.set( "second", 0 );
				future = future.set( "millisecond", 0 );

				return today <= end && end < future;
			},
			/**
				* Verify online tests
				* @param { Object } assignment to verify
				* @returns { Boolean }
			*/
			wasAttempted( assignment ) {
				let attempted = assignment.TESTS !== undefined && assignment.TESTS !== null && Array.isArray( assignment.TESTS ) && assignment.TESTS.length;
				let test = assignment.TESTS[ 0 ];

				return attempted && test.STUDENT_GRADED_ATTEMPTS !== undefined && test.STUDENT_GRADED_ATTEMPTS !== null && Array.isArray( test.STUDENT_GRADED_ATTEMPTS ) && test.STUDENT_GRADED_ATTEMPTS.length;
			},
			/**
				* Search and group the assignments by a specific category
				* @param { String } name category to search
				* @returns { Array }
			*/
			assignmentsByCategory( code ) {
				return this.grades.ASSIGNMENTS.slice().filter( assignment => assignment.ASSIGNMENT_CATEGORY_CODE === code );
			},
			/** Sort the assignments by latest due date */
			assignmentsByDate() {
				return _.orderBy(this.grades.ASSIGNMENTS, [ 'END_DATE', 'CREATED_DATE' ], [ 'asc', 'asc' ]);
			},
			goToClassPage() {
				let params = this.$route.params;
				
				this.$router.push({
					name: 'ClassPageHome',
					params: {
						courseSectionGUID: this.$route.params.courseSectionGUID
					},
				});
			},
		},
		created() {
			this.fetchMenu();
			this.fetchDetails();
			this.fetchCourse();
			this.fetchGrades();
			window.setTimeout( function () { $( "[data-toggle=\"popover\"]" ).popover(); }, 1000 );
		}
	}
</script>
